/**
 * Represent the Toast Type
 */
export enum ToasterType {
	ERROR = 'toast-type-error',
	SUCCESS = 'toast-type-success',
	WARNING = 'toast-type-warning',
	UPDATE_APP = 'update-app-required',
	NEW_RELEASE_LOG_APP = 'release_log_app',
	TOASTER = 'custom-toaster',
}
